export const paymentGateways = ["Stripe", "Adyen"];

export const roomChargeProviders = ["TigerTMS Room Charge", "StayntouchTms"];
